angular
  .module('TransitionManagementCtrl', [])
  .controller('TransitionManagementCtrl', function ($scope, Tabs, Models, IdentityFactory, SmartXFactory, FeatureFlags) {
    const activeTab = Tabs.getActiveTab();
   
    var performanceApi = SmartXFactory.getPerformanceAPI();
    $scope.platformId = performanceApi.platform;

    $scope.$on('smx-token-updated', function(e, token) {
      $scope.smartx_token = token;
    });

    IdentityFactory.getUser().then(function (res) {
      $scope.smartx_user_guid = res.profile.smartx_user_guid;
      $scope.smartx_token = res.access_token;
    });

    document.addEventListener('_TransitionManagementOpenTransition', function (event) {
      console.log('event', event);
        var tabs = Tabs.getTabs();
        var tabForAccount = _.find(tabs, function(tab){
          if (tab.type == 'allocation-holdings'){
            var allocation = tab.data.allocation;
            if (allocation){
              var account = allocation.account;
              return account.id == event.detail.account.id;
            }
          }
          return false;
        });

        if (tabForAccount) {
          Tabs.setActiveTab(tabForAccount);
          $rootScope.$broadcast('update-allocation-'+event.detail.account.id, event.detail);
          return;
        }
      
        Tabs.addTab('allocation-holdings', null, null, {allocation: event.detail});
        $scope.$apply();
    });
});